import { lazy } from "@bridgesplit/ui";

const ExploreMarkets = lazy(() => import("./ExploreMarkets"));
const ExploreCustodians = lazy(() => import("./ExploreCustodians"));
const ExploreRequests = lazy(() => import("./ExploreRequests"));
const ExploreLoops = lazy(() => import("./ExploreLoops"));

export { ExploreMarkets, ExploreCustodians, ExploreRequests, ExploreLoops };
export * from "./markets";
